export const PLOTLY_THEME_DEFAULTS = {
  margin: 50,
  legendMinWidth: 300,
  textColor: "#333333",
  textSecondaryColor: "rgba(0, 0, 0, 0.7)",
  dividerColor: "rgba(0, 0, 0, 0.12)",
  bgColor: "#ffffff",
}

export const AXIS_LAYOUT_KEY_PATTERN = /^(xaxis|yaxis)\d*$/
